import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';

const initialState = {
	notifications: [],
	notificationId: null,
};

export const notificationSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotifications: (state, { payload }) => {
			state.notifications = payload;
		},
		filterNotifications: (state, { payload }) => {
			const filteredNotifications = state.notifications.filter((d) => d.id !== payload);

			state.notifications = filteredNotifications;
		},
		setNotificationId: (state, { payload }) => {
			state.notificationId = payload;
		},
	},
});

const URL = process.env.REACT_APP_API_URL_V5;

export const { setNotifications, filterNotifications, setNotificationId } =
	notificationSlice.actions;

export const getNotifications = (salesmanId) => async (dispatch, getState) => {
	const invoice_date = getState()?.app?.invoiceDate;

	const CREDENTIALS = {
		url: `${URL}/notifications`,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		if (response) {
			dispatch(setNotifications(response.data));
		}

		return response;
	});
};
export const deleteNotifications = (data) => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/notifications/${data}`,
		method: 'delete',
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(filterNotifications(data));

		return response;
	});
};

export default notificationSlice.reducer;
